import { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { ChannelPartner } from 'src/interfaces/new-channel-partner/channelPartner';
import { IncompleteCpStatus, InvitedCpStatus } from 'src/enums/channel-partner';
import { useAuth } from 'src/hooks/use-auth';
import { Roles } from 'src/enums/role-based-auth-guard';
import { REPAIR_SERVICE_ID } from 'src/constants/repairRequest-constants';
import { EWASTE_SERVICE_ID } from 'src/constants/common-constant';

interface SubmitProfileCardProps {
  cpData: ChannelPartner;
  submitProfile: () => Promise<boolean>;
}

export const SubmitProfileCard: FC<SubmitProfileCardProps> = (props) => {
  const { cpData, submitProfile } = props;
  const auth = useAuth();
  const [mandatoryDocLength, setMandatoryDocLength] = useState<number>();
  const navigate = useNavigate();

  const setAllDetails = () => {
    setMandatoryDocLength(cpData.documentDetails.filter((item) => item.mandatory).length);
  };

  const onSubmit = async () => {
    const submitResult = await submitProfile();
    if (submitResult) {
      if (auth.user.scope !== Roles.CHANNEL_PARTNER) {
        navigate('/dashboard/channel-partners/main/invited');
      }
    }
  };

  const conditionForShowingErrorCard = () => (
    !cpData.managementDetails || !cpData.bankDetails?.ifscCode
      || mandatoryDocLength !== 3
      || (cpData.services[0]?.id === REPAIR_SERVICE_ID && cpData?.brandsProducts?.length < 1)
      || (cpData.services[0]?.id === EWASTE_SERVICE_ID && cpData?.dayAreas?.length < 1)
      || cpData.serviceAreaIds.length < 1
      || cpData.services.length < 1);

  const handleCancel = () => {
    if (cpData.status === IncompleteCpStatus.INCOMPLETE) {
      navigate('/dashboard/channel-partners/main/incomplete');
    } else {
      navigate('/dashboard/channel-partners/main/invited');
    }
  };
  useEffect(() => {
    setAllDetails();
  }, [cpData]);

  return (
    <>
      {(cpData.status === InvitedCpStatus.RESUBMIT
      || cpData.status === IncompleteCpStatus.INCOMPLETE)
      && (
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        sx={{
          my: 3
        }}
      >
        {(auth.user.scope !== Roles.CHANNEL_PARTNER) && (
        <Grid
          item
          display="contents"
        >
          <Button
            sx={{
              mr: 2
            }}
            color="primary"
            onClick={handleCancel}
            variant="outlined"
          >
            Cancel
          </Button>
        </Grid>

        )}
        <Grid
          item
          display="contents"
        >
          <Button
            sx={{
              mr: 2
            }}
            disabled={conditionForShowingErrorCard()}
            color="primary"
            onClick={onSubmit}
            variant="contained"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      )}
      {conditionForShowingErrorCard() && (
      <Card
        variant="outlined"
        sx={{
          mt: 1,
          borderColor: '#FFBDC2'
        }}
      >
        <CardContent
          sx={{
            backgroundColor: '#FFF0F1',
          }}
        >
          <Grid
            container
            spacing={1}
            direction="column"
          >
            { !cpData.managementDetails && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Management Details are missing
              </Typography>
            </Grid>
            )}
            { mandatoryDocLength !== 3 && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Mandatory KYC Documents are Missing
              </Typography>
            </Grid>
            )}
            { !cpData.bankDetails?.ifscCode && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Bank Details are Missing
              </Typography>
            </Grid>
            )}
            { cpData.serviceAreaIds?.length < 1 && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Service Areas are Missing
              </Typography>
            </Grid>
            )}
            { cpData.services?.length < 1 && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Services are Missing
              </Typography>
            </Grid>
            )}
            { cpData?.dayAreas?.length < 1
            && cpData.services[0]?.id === EWASTE_SERVICE_ID && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Pincode Day Mapping are Missing
              </Typography>
            </Grid>
            )}
            { cpData?.brandsProducts?.length < 1
            && cpData.services[0]?.id === REPAIR_SERVICE_ID && (
            <Grid
              item
            >
              <Typography
                color="red"
                variant="body2"
              >
                * Brand and Product are Missing
              </Typography>
            </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
      )}
    </>
  );
};

SubmitProfileCard.propTypes = {
  // @ts-ignore
  cpData: PropTypes.object,
  submitProfile: PropTypes.func,
};
